/**
 * PROPRIETARY AND CONFIDENTIAL
 * Copyright © 2026 Contractor Co-Pilot. All Rights Reserved.
 */

export interface EstimateLike {
  estimate_id: string;
}

export interface InvoiceEstimateLink {
  estimate_id: string | null;
}

export function collectEstimateIdsWithInvoices(
  invoices: InvoiceEstimateLink[],
): Set<string> {
  return new Set(
    invoices
      .map((invoice) => invoice.estimate_id)
      .filter((id): id is string => !!id),
  );
}

export function filterEstimatesWithoutInvoices<TEstimate extends EstimateLike>(
  estimates: TEstimate[],
  invoices: InvoiceEstimateLink[],
): TEstimate[] {
  const idsWithInvoices = collectEstimateIdsWithInvoices(invoices);
  return estimates.filter(
    (estimate) => !idsWithInvoices.has(estimate.estimate_id),
  );
}
